export enum AlbumSortBy {
	MOST_RECENT = "MOST_RECENT",
	POPULAR_ALBUMS = "POPULAR_ALBUMS",
	MY_ALBUMS = "MY_ALBUMS"
}
